import styled from 'styled-components';

type Props = {
    lat: number;
    lng: number;
}

// This is to prevent to use ts-ignore in div lat={lat} lng={lng} in GoogleMapsPin component
export const PinWrapper = styled.div<Props>``;